export const validateEmail = (email: string): string | null => {
    if (!email) return "Email is required";

    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!re.test(email)) return "Invalid email format";

    return null;
};

export const validateMobile = (
    phone: string,
    country: string
): string | null => {
    const cleaned = phone.replace(/\D/g, "");

    if (country === "IN") {
        if (!/^[6-9]\d{9}$/.test(cleaned)) {
            return "Enter valid Indian mobile number";
        }
    }

    if (country === "AE") {
        if (!/^5\d{8}$/.test(cleaned)) {
            return "Enter valid UAE mobile number";
        }
    }

    return null; // valid
};

export const validateZipcode = (value: string) => {
    console.log(value, "value")
    return /^\d{6}$/.test(value);
};

